export default __webpack_public_path__ + "static/media/coloring_squirrel.8243cdb3.png";